import idx from 'idx'

export const getIdToken = () => {
  const userSession = localStorage.getItem('session')
  return idx(JSON.parse(userSession), _ => _.id_token)
}
